import React, { useState, useEffect } from 'react';
import trainingSimulationService from '../api';

const ScenarioSelector = ({ onScenarioSelect, selectedScenarioId }) => {
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchScenarios = async () => {
      try {
        setLoading(true);
        const data = await trainingSimulationService.getScenarios();
        setScenarios(data);
        setError(null);
      } catch (err) {
        setError('Failed to load scenarios. Please try again.');
        console.error('Error loading scenarios:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchScenarios();
  }, []);

  if (loading) {
    return (
      <div className="p-4 bg-white rounded-lg shadow-sm">
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-4 py-1">
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 bg-red-50 text-red-700 rounded-lg">
        <p>{error}</p>
        <button 
          className="mt-2 px-4 py-2 bg-red-100 hover:bg-red-200 rounded-md text-sm"
          onClick={() => window.location.reload()}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      <h3 className="text-lg font-medium mb-4">Select Training Scenario</h3>
      <div className="gap-4">
        {scenarios.map((scenario) => (
          <div 
            key={scenario.id}
            className={`p-4 rounded-lg border-2 cursor-pointer transition-all mb-4 ${
              selectedScenarioId === scenario.id 
                ? 'border-blue-500 bg-blue-50' 
                : 'border-gray-200 hover:border-blue-300'
            }`}
            onClick={() => onScenarioSelect(scenario.id)}
          >
            <h4 className="font-medium text-gray-900">{scenario.title}</h4>
            <div className="mt-2 flex items-center">
              <span className={`inline-block w-2 h-2 rounded-full mr-2 ${
                scenario.difficulty === 'easy' ? 'bg-green-500' :
                scenario.difficulty === 'medium' ? 'bg-yellow-500' : 'bg-red-500'
              }`}></span>
              <span className="text-sm text-gray-600 capitalize">{scenario.difficulty}</span>
            </div>
            <p className="mt-2 text-sm text-gray-600">{scenario.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScenarioSelector;